// extracted by mini-css-extract-plugin
module.exports = {"moreInformation":"style-module_moreInformation__yiShgnZIccbqwqOg1FEZ7"};